module.exports = __webpack_public_path__ + "static/media/cert_135.13c8f0ad.jpg";